import styled from 'styled-components';

export const IconButtonStyled = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #858585;
  border-radius: 50%;
  overflow: hidden;
  &.selected {
    border: 2px solid #005bd3;
  }
`;
